import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomers = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 10.5553,
			cy: 7.50016,
			rx: 4.66667,
			ry: 4.66667,
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 10.5553,
			cy: 20.3346,
			rx: 8.16667,
			ry: 4.66667,
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5543 20.334C24.5543 22.267 22.1795 23.8339 19.28 23.8339C20.1343 22.9002 20.7217 21.7282 20.7217 20.3356C20.7217 18.9414 20.1329 17.7683 19.2771 16.834C22.1766 16.834 24.5543 18.401 24.5543 20.334Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0543 7.50098C21.0543 9.43397 19.4873 11.001 17.5543 11.001C17.1328 11.001 16.7287 10.9265 16.3545 10.7899C16.9064 9.81913 17.2217 8.69621 17.2217 7.49967C17.2217 6.30402 16.9069 5.18188 16.3557 4.2116C16.7296 4.07532 17.1333 4.00098 17.5543 4.00098C19.4873 4.00098 21.0543 5.56798 21.0543 7.50098Z",
			fill: "#808080"
		})
	]
});
const ForwardRef = forwardRef(SvgCustomers);
export default ForwardRef;
